export default __webpack_public_path__ + "static/experimentation-works-90ae7e5978f692c889382270c81727b5.jpg";